import { Phone } from '../../ui';
import { Qr } from '../industries/Vignettes';

/** A neutral, illustrative delivery note with a scannable code. No customer data. */
export function PackingSlip() {
  const lines = [
    { p: 'Machined housing', l: 'HX-4410', q: '24' },
    { p: 'Flange, 316L', l: 'FL-2316', q: '40' },
    { p: 'Shaft assembly', l: 'SA-1102', q: '12' },
  ];
  return (
    <div className="relative rounded-[6px] bg-white p-6 text-bm-ink shadow-[0_40px_80px_-40px_rgba(24,19,67,.45),0_0_0_1px_#E4E3F0] sm:p-7" aria-hidden="true">
      <div className="flex items-start justify-between gap-6">
        <div>
          <div className="text-[18px] font-extrabold tracking-[-0.02em] text-bm-indigo">Delivery note</div>
          <div className="mt-1 font-mono text-[11px] text-bm-muted">Despatch 24-1182 · from your ERP</div>
        </div>
        <div className="text-right font-mono text-[10.5px] leading-relaxed text-bm-muted">
          <div>Page 1 of 1</div>
          <div>3 lines</div>
        </div>
      </div>
      <table className="mt-6 w-full text-left text-[12.5px]">
        <thead>
          <tr className="border-b border-bm-ink/80 font-mono text-[10px] uppercase tracking-[0.08em] text-bm-muted">
            <th className="pb-2 font-medium">Part</th>
            <th className="pb-2 font-medium">Part no.</th>
            <th className="pb-2 text-right font-medium">Qty</th>
          </tr>
        </thead>
        <tbody>
          {lines.map((r) => (
            <tr key={r.p} className="border-b border-bm-line">
              <td className="py-2.5">{r.p}</td>
              <td className="py-2.5 font-mono text-[11.5px]">{r.l}</td>
              <td className="py-2.5 text-right font-mono text-[11.5px]">{r.q}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="mt-6 flex items-center gap-4 rounded-xl bg-bm-alt p-4">
        <div className="rounded-lg bg-white p-1.5 ring-1 ring-bm-line">
          <Qr size={64} />
        </div>
        <div className="text-[12.5px] leading-snug">
          <div className="font-semibold text-bm-indigo">Something wrong with this delivery?</div>
          <div className="mt-0.5 text-bm-muted">Scan to see exactly what shipped and report damaged, faulty or missing items.</div>
        </div>
      </div>
    </div>
  );
}

/** The scan result: a case opened with the order and line attached. */
export function CasePhone() {
  return (
    <Phone>
      <div className="flex h-full flex-col bg-[#F7F7FC] text-[11.5px] text-bm-ink">
        <div className="bg-white px-4 pb-4 pt-10">
          <div className="text-[10px] uppercase tracking-[0.12em] text-bm-muted">Despatch 24-1182</div>
          <div className="mt-1 text-[16px] font-bold leading-tight tracking-[-0.02em] text-bm-indigo">Report a problem</div>
        </div>
        <div className="space-y-2 p-3">
          <div className="rounded-xl bg-white p-3 ring-1 ring-bm-line">
            <div className="text-[10px] uppercase tracking-[0.08em] text-bm-muted">Which line?</div>
            <div className="mt-2 flex items-center justify-between rounded-lg bg-[#EEF8F1] px-2.5 py-2 ring-1 ring-bm-green">
              <span className="font-semibold">Flange, 316L</span>
              <span className="font-mono text-[10px]">FL-2316</span>
            </div>
          </div>
          <div className="rounded-xl bg-white p-3 ring-1 ring-bm-line">
            <div className="text-[10px] uppercase tracking-[0.08em] text-bm-muted">What happened?</div>
            <div className="mt-2 flex flex-wrap gap-1.5">
              {['Damaged', 'Missing', 'Wrong part', 'Paperwork'].map((t, i) => (
                <span key={t} className={i === 0 ? 'rounded-full bg-bm-indigo px-2.5 py-1 text-[10.5px] font-semibold text-white' : 'rounded-full px-2.5 py-1 text-[10.5px] ring-1 ring-bm-line'}>
                  {t}
                </span>
              ))}
            </div>
          </div>
          <div className="rounded-xl bg-white p-3 ring-1 ring-bm-line">
            <div className="text-[10px] uppercase tracking-[0.08em] text-bm-muted">Attached automatically</div>
            <ul className="mt-1.5 space-y-1 text-[11px]">
              <li>Order and despatch</li>
              <li>Part and quantity</li>
              <li>Your 2 photos</li>
            </ul>
          </div>
        </div>
        <div className="mt-auto p-3">
          <div className="rounded-xl py-2.5 text-center text-[11.5px] font-semibold text-bm-indigo" style={{ background: 'var(--bm-gradient)' }}>
            Open case
          </div>
          <div className="pt-2 text-center text-[8.5px] text-bm-muted">Powered by BrandedMark</div>
        </div>
      </div>
    </Phone>
  );
}
